import { h, render } from 'preact';
import { riperStorage, Utils } from '@/base/helpers';
import CheckoutButton from './CheckoutButton';

const CheckoutButtonRenderer = {
  _containers: [],
  setContainers() {
    this._containers = [];
    const isMobile = Utils.getScreenWidth() < 768;
    const oscd =
      document.getElementsByClassName('order-summary__section--discount')[0] ||
      document.getElementsByClassName('cart-section optimizedCheckout-orderSummary-cartSection')[1] ||
      document.getElementsByClassName('form-fieldset redeemable-payments')[0] ||
      (isMobile &&
        (document.querySelector('.optimizedCheckout-contentPrimary') ||
          document.getElementsByClassName('checkout-steps')[0]));

    if (oscd) {
      const c0 = document.createElement('div');
      c0.className += ' beans-checkout';
      oscd.appendChild(c0);
      this._containers.push({
        target: c0,
        type: CheckoutButton,
      });
    }
    return this._containers;
  },
  render(CheckoutButtonComponent) {
    this._containers.forEach(function (container) {
      const TagName = container.type;
      container.node = (
        <TagName
          account={riperStorage.account}
          cart={riperStorage.cart}
          coupon={riperStorage.coupon}
          display={riperStorage.riperDisplay}
          onAbout={riperStorage.onAbout}
          CheckoutButtonComponent={CheckoutButtonComponent}
        />
      );
      container.target.innerHTML = '';
      render(container.node, container.target);
    });
  },
};

export default CheckoutButtonRenderer;
